import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { filter, takeUntil } from "rxjs/operators";

@Component({
  selector: 'calsoft-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  url: string = '';


  sanitizedUrl = '';



  isLoading: Subject<boolean> = this.loaderService.isLoading;

  showLoader: boolean = true;
  constructor(
    private router: Router,
    private loaderService: LoaderService) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
  }

  mode = 'indeterminate';

  ngOnInit(): void {

    this.url = this.router.url;
  }

  protected _onDestroy = new Subject<void>();

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
